import { useEffect, useState } from 'react';
import { TodoModelAPI } from '../TodoModelAPI';
import { CRMModelAPI } from '../../CRMModel/CRMModelAPI';

/**
 * Custom hook to poll the count of today's reminders for the current operator:
 * active call todos plus open CRM comments due today (the call-calendar sources).
 * Polls every 60 seconds when enabled.
 *
 * @param {boolean} enabled - Whether to enable polling (default: true)
 * @returns {number} The current count of today's reminders
 */
export const useReminderNotifications = (enabled: boolean = true): number => {
    const [reminderCount, setReminderCount] = useState<number>(0);

    const fetchReminderCount = async () => {
        try {
            const [todoCount, crmCount] = await Promise.all([
                TodoModelAPI.getTodayReminderCount(),
                CRMModelAPI.getTodayReminderCount(),
            ]);
            setReminderCount(todoCount + crmCount);
        } catch (err) {
            console.error('Error fetching reminder count:', err);
        }
    };

    useEffect(() => {
        if (!enabled) {
            return;
        }

        // Fetch immediately on mount
        fetchReminderCount();

        // Poll every 60 seconds
        const interval = setInterval(fetchReminderCount, 60000);

        return () => {
            clearInterval(interval);
        };
    }, [enabled]);

    return reminderCount;
};
